let baseTitle: string | null = null

const isSafari = (): boolean => {
    if (typeof navigator === 'undefined') return false
    const ua = navigator.userAgent
    // Match Safari (including desktop) while excluding Chrome/Edge/Opera and iOS Chrome
    return /Safari/i.test(ua) && !/(Chrome|CriOS|OPR|Edg)/i.test(ua)
}

const getBaseTitle = (): string => {
    if (baseTitle) return baseTitle
    baseTitle = document.title || 'Optimo'
    return baseTitle
}

export const setTabTitleCount = (count: number): void => {
    const title = getBaseTitle()
    if (!count || count <= 0) {
        document.title = title
        return
    }
    const display = count > 99 ? '99+' : count.toString()
    // On Safari, avoid leading (N) which can render awkwardly in tab lists.
    // Use a suffix with a bullet instead.
    if (isSafari()) {
        document.title = `${title} • ${display}`
    } else {
        document.title = `(${display}) ${title}`
    }
}

export const resetTabTitleCount = (): void => {
    if (baseTitle) document.title = baseTitle
}
